import { get, del, put } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  getTasteimonials: async params => {
    const options = { url: apiEndpoints.tasteimonials, params: { ...params } };
    return get(options);
  },
  getWineLoverNames: async () => {
    const options = { url: apiEndpoints.tasteimonialsWineLoverNames };
    return get(options);
  },
  getSPListNames: async () => {
    const options = { url: apiEndpoints.tasteimonialsSPListNames };
    return get(options);
  },
  getProducersNames: async params => {
    const options = { url: apiEndpoints.tasteimonialsProducersNames, params: { ...params } };
    return get(options);
  },
  getWinesNames: async params => {
    const options = { url: apiEndpoints.tasteimonialsWinesNames, params: { ...params } };
    return get(options);
  },
  getMenusNames: async params => {
    const options = { url: apiEndpoints.tasteimonialsMenusNames, params: { ...params } };
    return get(options);
  },
  removeMany: async ids => {
    const options = {
      url: apiEndpoints.tasteimonials,
      data: { ids },
    };
    return del(options);
  },
  updateStatus: async data => {
    const options = {
      url: apiEndpoints.tasteimonials,
      data,
    };
    return put(options);
  },
  updateResponse: async (id, response) => {
    const options = {
      url: apiEndpoints.tasteimonialResponse.replace(':id', id),
      data: { noteResponse: response },
    };
    return put(options);
  },
};
